import NumberInput from "@solundo/webshop/js/NumberInput/NumberInput";
import Events from "@wwdev/bootstrap/Events";

class Overview {
	constructor(config) {
		this.config = Object.assign({
			scope: '[package="cms-product"]',
			form: '[data-overview="form"]',
			success: '[data-overview="success"]',
			error: '[data-overview="error"]',
			errorMessage: '[data-overview="error-message"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		new NumberInput({
			scope: `${this.config.scope} [data-number="scope"]`
		});
	}

	addEventListeners() {
		this.$scope.on('submit', this.config.form, this.addToCart.bind(this));
	}

	addToCart(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		this._before($form);

		$.ajax({
			url: $form.attr('action'),
			method: "POST",
			data: $form.serializeObject(),
			success: this._onSuccess.bind(this, $form),
			error: this._onError.bind(this, $form),
		}).always(this._after.bind(this, $form));
	}

	_onSuccess($form, response) {
		(bootstrap.Toast.getOrCreateInstance(this.config.error));
		let toast = bootstrap.Toast.getOrCreateInstance(this.config.success);
		toast.show();
		Events.trigger('wwdev.winkelwagen.indicator.refresh');
	}

	_onError($form, response) {
		(bootstrap.Toast.getOrCreateInstance(this.config.success)).hide();
		$(this.config.errorMessage).html(response.responseJSON.message);
		let toast = bootstrap.Toast.getOrCreateInstance(this.config.error);
		toast.show();
	}

	_before($form) {
		showLoader();
	}

	_after($form, response) {
		hideLoader();
	}
}

export default new Overview;